import type { ReactNode, SVGProps } from 'react'

/**
 * Het vinkje bij "opgeslagen", in Lucide-stijl (ontwerp 10.2). Naast de bestaande
 * statustekst en niet in plaats ervan; decoratief (`aria-hidden`).
 */
export function CheckIcon(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      // Inline en niet via een CSS-klasse: dit component wordt zowel geladen waar
      // schil.css als waar alleen tokens.css staat (de configurator), en de token zelf
      // is overal aanwezig.
      style={{ width: 'var(--nwo-space-sp-4)', height: 'var(--nwo-space-sp-4)', flexShrink: 0 }}
      focusable="false"
      {...props}
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  )
}
